import { useEffect, useState } from 'react'

async function fetchTerms() {
    const response = await fetch('/terms')
    const data = await response.text()
    return data
}

export function Terms() {
    const [terms, setTerms] = useState('')
    useEffect(() => {
        fetchTerms().then(setTerms)
    }, [])
    // `w-max` sized this to its widest line, which for a 700-line legal document means the dialog
    // scrolled sideways rather than wrapping. A block element already fills its parent; the only
    // thing needed here is a readable measure.
    return <div className='mx-auto max-w-full' dangerouslySetInnerHTML={{ __html: terms }}></div>
}
